import { render, staticRenderFns } from "./APIDoc.vue?vue&type=template&id=16ff03cd&scoped=true&"
import script from "./APIDoc.vue?vue&type=script&lang=js&"
export * from "./APIDoc.vue?vue&type=script&lang=js&"
import style0 from "./APIDoc.vue?vue&type=style&index=0&id=16ff03cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ff03cd",
  null
  
)

component.options.__file = "APIDoc.vue"
export default component.exports